import React from 'react';

const PublicPaymentPortal = () => {
  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
        <h1 className="text-2xl font-bold text-secondary-900 mb-4">Payment Portal</h1>
        <p className="text-secondary-600 mb-6">Payment processing is currently disabled.</p>
        <p className="text-sm text-secondary-500">
          Please contact support for payment assistance.
        </p>
      </div>
    </div>
  );
};

export default PublicPaymentPortal;